import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PUBLIC_PAGE_DETAILS_GET } from '../../redux/actions/public';
import { Section } from './style';
import routes from '../../../routes';
import PublicPageComponent from '../../../ui/components/PublicPageComponent';
import {
  getPageDescriptionByPath,
  getPageTitleByPath,
} from '../../../utils/labels';
import { feBaseUrl } from '../../api/config';

const PublicPage = ({
  header,
  homepage,
  footer,
  subFooter,
  pageContent,
  getPageDetails,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [firstArticle, setFirstArticle] = useState();

  const isInternalPage = (link = {}) => {
    return ['page_link', 'privacy_policy'].includes(link?.type);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      (header && Object.keys(header)?.length > 0) ||
      (footer && Object.keys(footer)?.length > 0)
    ) {
      const headerPaths = (header || []).filter((i) => isInternalPage(i));
      const footerPaths = (footer || []).filter((i) => isInternalPage(i));
      const subfooterPaths = (subFooter || []).filter((i) => isInternalPage(i));
      const allPaths = [...headerPaths, ...footerPaths, ...subfooterPaths].map(
        (i) => i.data
      );
      const thisPage = allPaths.find((p) => p?.path === pathname);

      if (thisPage) getPageDetails(thisPage?.page);
      else {
        getPageDetails(homepage?.data);
        navigate(routes.public.path);
      }
    } else if (homepage?.data) getPageDetails(homepage?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, header, homepage, footer, subFooter]);

  useEffect(() => {
    if (pageContent?.page_elements?.length) {
      setFirstArticle(
        pageContent?.page_elements?.findIndex(
          (e) => e?.type === PublicPageComponent.TYPES.ARTICLE
        )
      );
    }
  }, [pageContent]);

  return (
    <>
      <Helmet>
        <title>{getPageTitleByPath(pathname)}</title>
        <link rel="canonical" href={`${feBaseUrl}${pathname}`} />
        <meta name="description" content={getPageDescriptionByPath(pathname)} />
      </Helmet>
      {(pageContent?.page_elements || []).map(
        ({ type, data, title, body, background }, i) => (
          <Section
            key={`${type}-${i}`}
            index={i}
            type={type}
            className={data?.data?.type ? data?.data?.type : ''}
          >
            <PublicPageComponent
              type={type}
              data={data}
              title={title}
              body={body}
              background={background}
              firstArticle={i === firstArticle}
            />
          </Section>
        )
      )}
    </>
  );
};

PublicPage.propTypes = {
  header: PropTypes.array,
  footer: PropTypes.array,
  subFooter: PropTypes.array,
  homepage: PropTypes.object,
  pageContent: PropTypes.object,
  getPageDetails: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      homepage,
      pageContent,
      menuLinks: header,
      footer,
      subFooter,
    } = state.publicSite;
    const { navigationMobile } = state.app;
    return {
      header,
      homepage,
      footer,
      navigationMobile,
      pageContent,
      subFooter,
    };
  },
  (dispatch) => ({
    getPageDetails: (id) =>
      dispatch({ type: PUBLIC_PAGE_DETAILS_GET._REQUEST, id }),
  })
)(PublicPage);
